import { EvidenceBlock } from 'app/types/Infermedica';
import { TriageBlockConfig } from './TriageBlock';
import * as ChiefComplaintBlock from './blocks/ChiefComplaintBlock';
import * as SuggestSymptomsBlock from './blocks/SuggestSymptomsBlock';
import * as DiagnoseBlock from './blocks/DiagnoseBlock';
import * as EvaluateBlock from './blocks/EvaluateBlock';
import * as AgreeToTermsBlock from './blocks/AgreeToTermsBlock';
import * as DisqualifyBlock from './blocks/DisqualifyBlock';
import * as ProtocolizedVisitBlock from './blocks/ProtocolizedVisitBlock';

export type TriageBlockCodes =
  | 'chiefComplaint'
  | 'suggestSymptoms'
  | 'diagnose'
  | 'evaluate'
  | 'agreeToTerms'
  | 'disqualify'
  | 'protocolizedVisit';

export const TriageBlocks: Record<TriageBlockCodes, TriageBlockConfig> = {
  chiefComplaint: ChiefComplaintBlock,
  suggestSymptoms: SuggestSymptomsBlock,
  diagnose: DiagnoseBlock,
  evaluate: EvaluateBlock,
  agreeToTerms: AgreeToTermsBlock,
  disqualify: DisqualifyBlock,
  protocolizedVisit: ProtocolizedVisitBlock,
};

export interface TriageDatabase {
  chiefComplaint?: Record<string, unknown>;
  agreeToTerms?: Record<string, unknown>;
  disqualify?: Record<string, unknown>;
  protocolizedVisit: Record<string, unknown>;
  suggestSymptoms?: Record<string, unknown>;
  diagnose?: Record<string, unknown>;
  evaluate?: Record<string, unknown>;
  evidence: Record<string, EvidenceBlock[] | undefined>;
}
